import React, { useContext } from "react"
import { OutlinedButton, ValidationError } from "dash-styled"
import { ReactComponent as AddIcon } from "icons/lib/plus.svg"

import { DocumentType } from "../../../../../../Models/DataProgram/DocumentExtraction"
import {
    DocumentsListProps,
    useDocumentsList
} from "../../Common/Hooks/useDocumentsList"
import { DocumentsExtractionContext } from "../../DocumentsExtractionContext"
import { DocumentEdit } from "./DocumentEdit"
import { DocumentsListItem } from "./DocumentsListItem"

export const DocumentsList = (props: DocumentsListProps) => {
    const {
        newDocumentView: [isOpen, open, close],
        documentsSchema,
        documentsErrors,
        documents,
        onDocumentAdd,
        onDocumentEdit,
        onDocumentDelete
    } = useDocumentsList(props)

    const { annotationsOutputList, setAnnotationsOutputList } = useContext(
        DocumentsExtractionContext
    )

    const handleDocumentDelete = (index: number) => () => {
        onDocumentDelete(index)()
        if (annotationsOutputList) {
            setAnnotationsOutputList({
                ...annotationsOutputList,
                annotations: {}
            })
        }
    }

    return (
        <>
            {isOpen ? (
                <DocumentEdit
                    schema={documentsSchema}
                    onSubmit={onDocumentAdd}
                    onClose={close}
                    templates={[]}
                />
            ) : (
                <div className="flex flex-col max-h-full h-full relative">
                    {documents.length === 0 && (
                        <OutlinedButton
                            label="New document"
                            Icon={AddIcon}
                            className="self-end py-3 mb-4 mt-2.5 mr-2.5 bg-white border-gray-500"
                            onClick={open}
                        />
                    )}
                    {documentsErrors?.__errors?.[0] && (
                        <ValidationError className="mr-1">
                            {documentsErrors?.__errors?.[0]}
                        </ValidationError>
                    )}
                    {documents
                        .filter((doc: DocumentType) => doc !== undefined)
                        ?.map((document: DocumentType, index: number) => (
                            <React.Fragment
                                key={`${document?.documentType}_${index}`}
                            >
                                <DocumentsListItem
                                    schema={documentsSchema}
                                    value={document}
                                    onDelete={handleDocumentDelete(index)}
                                    onEdit={onDocumentEdit(index)}
                                />
                                {documentsErrors?.[index] && (
                                    <ValidationError className="mr-1 mb-4">
                                        {
                                            documentsErrors?.[index]
                                                ?.annotationFields
                                                ?.__errors?.[0]
                                        }
                                    </ValidationError>
                                )}
                            </React.Fragment>
                        ))}
                </div>
            )}
        </>
    )
}
